import { z } from "zod";

// Transform empty strings to null
const emptyToNull = z
	.string()
	.nullish()
	.transform((val) => (val === "" ? null : val));

export const getB2BPromoFormSchema = () => {
	return z.object({
		b2b: emptyToNull,
		promoCode: emptyToNull,
	});
};

export type B2BPromoFormModel = z.infer<
	ReturnType<typeof getB2BPromoFormSchema>
>;
